// Foundation JavaScript
// Documentation can be found at: http://foundation.zurb.com/docs

jQuery(document).ready(function() {
  jQuery(document).foundation();

  return jQuery(document).on("click", ".m-icon, .js-off-canvas-overlay", function() {
    return jQuery(".m-icon .icon").toggleClass("active");
  });

});

jQuery(document).on("click", "#mega-icon", function() {
	jQuery(this).find('.icon').toggleClass("active");
	jQuery('.megamenu').toggleClass("active");
});

jQuery(document).on("click", ".menu-icon", function(){
    jQuery('.menu-icon').toggleClass("active");
});

jQuery('[data-toggle]').on('click', function() {
	jQuery(document).trigger('click.zf.trigger', '[data-toggle]');
});



function mobile_only_carousel() {

  if( jQuery(window).width() < 640 ) {
  		/* Slick Slider */

		  jQuery('.product-cat-carousel').slick({
			  autoplaySpeed: 5000,
			  slidesToShow: 1,
			  centerMode: true,
			  centerPadding: '50px',
			  infinite: true,
			  arrows: false,
			  dots: false,
			  autoplay: true,
			  initialSlide: 1,
		  });
	}

}

jQuery(document).ready(function () {
  mobile_only_carousel();
});

jQuery(window).resize(function(){
  mobile_only_carousel();
});


/* Doc ready */

jQuery(function($) {

	/*

	var a = 0;

	jQuery(window).scroll(function () {

		let site_header = $('.site-header');
		let position = 100;

		if ( $(this).scrollTop() > position ) {
			site_header.addClass('bg');
		} else if ( $(this).scrollTop() < position ) {
			site_header.removeClass('bg');
		}

	});


	var lightbox = jQuery('a.lightbox').simpleLightbox();

	jQuery(document).on('click', '.lightbox-enlarge', function() {
	    lightbox.open();
	});
	*/


});


/* Gallery */

jQuery(".gallery").justifiedGallery({
	rowHeight : 220,
	lastRow : 'nojustify',
	captions : false,
	margins : 10
});



/* Make Embeds Responsive */

jQuery(document).ready(function() {

	/* Magnific Popup */

	jQuery('.gallery').magnificPopup({
		delegate: 'a',
		type: 'image',
		closeOnContentClick: false,
		closeBtnInside: false,
		mainClass: 'mfp-with-zoom mfp-img-mobile',
		image: {
			verticalFit: true,
		},
		gallery: {
			enabled: true
		},
		zoom: {
			enabled: true,
			duration: 300, // don't foget to change the duration also in CSS
			opener: function(element) {
				return element.find('img');
			}
		}

	});

	jQuery('.single-post iframe').wrap('<div class="responsive-embed" />');

});

